/**
 * Global Base Styles
 *
 * brandConfig (the empty-state sprout, on plant photos, tiles and rows) and
 * GlobalStyle (App). The cva bases, stage theme and garden theme that once
 * sat here were imported by nothing and are gone.
 *
 * Used by: App (GlobalStyle) and the plant photo, row and tile
 * (brandConfig).
 *
 * @module styles/base
 */

import { createGlobalStyle, keyframes } from 'styled-components';
import { Sprout } from 'lucide-react';

/**
 * Brand configuration
 * Defines core brand elements like icons that are used across the application
 */
export const brandConfig = {
  emptyStateIcon: Sprout,
  iconSizes: {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
    xl: 'h-12 w-12'
  }
} as const;

/** One full turn, for the .Spinner class below. */
const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

/** Page-wide CSS mounted once by App: the .Spinner class's turn. */
export const GlobalStyle = createGlobalStyle`
  .Spinner {
    animation: ${spin} 1s linear infinite;
    color: var(--primary-color);
  }
`;